var exports = {
  "$L": "AuthLoginBrowserStep.module__browserPane___QkU1QW",
  "aC": "AuthLoginBrowserStep.module__browserInstanceRow___QkU1QW",
  "AC": "AuthLoginBrowserStep.module__browserInstanceIdentity___QkU1QW",
  "b0": "AuthLoginBrowserStep.module__browserInstanceLogo___QkU1QW",
  "xE": "AuthLoginBrowserStep.module__browserInstanceMeta___QkU1QW",
  "l_": "AuthLoginBrowserStep.module__browserInstanceNameRow___QkU1QW",
  "BN": "AuthLoginBrowserStep.module__browserInstanceName___QkU1QW",
  "uw": "AuthLoginBrowserStep.module__browserInstanceOfficialBadge___QkU1QW",
  "i4": "AuthLoginBrowserStep.module__browserInstanceDomain___QkU1QW",
  "Pt": "AuthLoginBrowserStep.module__browserStatusPanel___QkU1QW",
  "Nu": "AuthLoginBrowserStep.module__browserStatusTitle___QkU1QW",
  "ge": "AuthLoginBrowserStep.module__browserStatusText___QkU1QW",
  "XJ": "AuthLoginBrowserStep.module__browserManualPanel___QkU1QW",
  "a$": "AuthLoginBrowserStep.module__browserCode___QkU1QW",
  "SO": "AuthLoginBrowserStep.module__browserTimer___QkU1QW",
  "CK": "AuthLoginBrowserStep.module__browserTextButton___QkU1QW",
  "aU": "AuthLoginBrowserStep.module__browserFooter___QkU1QW",
};

module.exports = exports;
